import { render } from "./App.vue?vue&type=template&id=f8c6ffc2"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=f8c6ffc2&lang=scss"

import exportComponent from "E:\\My Websites\\v12\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__